export default class {
	idItemPedido

	constructor(idItemPedido) {
		this.idItemPedido = idItemPedido
	}
}
